import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/AIHeuristicCard/home/heuristic-card.png';
import _imports_1 from '@/assets/images/AIHeuristicCard/home/game-map.png';
import _imports_2 from '@/assets/images/AIHeuristicCard/home/ai-design.png';
const _withScopeId = n => (_pushScopeId("data-v-884c7a42"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home-footer"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "title common-text"
};
const _hoisted_4 = {
  class: "detail"
};
const _hoisted_5 = {
  class: "detail-item common-text"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_7 = {
  class: "detail-item common-text"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_9 = {
  class: "detail-item common-text"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1));
import i18n from '@/language/index';
export default {
  __name: 'FooterContent',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("p", {
        class: _normalizeClass(_unref(i18n).global.locale.value === 'en' ? 'title-en' : '')
      }, _toDisplayString(_ctx.$t('aiHeuristicCard.home.footerTitle')), 3)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("p", {
        class: _normalizeClass(["detail-title", _unref(i18n).global.locale.value === 'en' ? 'detail-en' : ''])
      }, _toDisplayString(_ctx.$t('aiHeuristicCard.home.heuristicCard')), 3), _createElementVNode("p", {
        class: _normalizeClass(["detail-content common-text", _unref(i18n).global.locale.value === 'en' ? 'detail-en' : ''])
      }, _toDisplayString(_ctx.$t('aiHeuristicCard.home.heuristicCardDesc')), 3)]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("p", {
        class: _normalizeClass(["detail-title", _unref(i18n).global.locale.value === 'en' ? 'detail-en' : ''])
      }, _toDisplayString(_ctx.$t('aiHeuristicCard.home.gameMap')), 3), _createElementVNode("p", {
        class: _normalizeClass(["detail-content common-text", _unref(i18n).global.locale.value === 'en' ? 'detail-en' : ''])
      }, _toDisplayString(_ctx.$t('aiHeuristicCard.home.gameMapDesc')), 3)]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("p", {
        class: _normalizeClass(["detail-title", _unref(i18n).global.locale.value === 'en' ? 'detail-en' : ''])
      }, _toDisplayString(_ctx.$t('aiHeuristicCard.home.AiDesignComponent')), 3), _createElementVNode("p", {
        class: _normalizeClass(["detail-content common-text", _unref(i18n).global.locale.value === 'en' ? 'detail-en' : ''])
      }, _toDisplayString(_ctx.$t('aiHeuristicCard.home.AiDesignComponentDesc')), 3)])])])]);
    };
  }
};